import { Button, SxProps, Tooltip, useTheme } from "@mui/material";
import { Control, Controller, Path } from "react-hook-form";

import { TaskFormType } from "./types";

export const TaskFormButton = ({
  icon,
  label,
  onClick,
  sx,
  control,
  name,
  tooltipTitle,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps;
  control: Control<TaskFormType>;
  name: Path<TaskFormType>;
  tooltipTitle?: string;
}) => {
  const theme = useTheme();
  const title = tooltipTitle ?? label;

  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState: { error } }) => (
        <Tooltip title={title} arrow>
          <Button
            startIcon={icon}
            onClick={(e) => onClick(e)}
            variant="outlined"
            aria-label={title}
            sx={{
              textTransform: "none",
              color: theme.palette.text.secondary,
              borderColor: error ? theme.palette.error.main : theme.palette.grey[300],
              fontWeight: 400,
              ...sx,
            }}
          >
            {label}
          </Button>
        </Tooltip>
      )}
    />
  );
};
